import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const PastorItem = ({
  canEdit,
  data,
  npoId
}: {
  canEdit: boolean;
  data: NonProfitOrgProfileResponse['pastors'];
  npoId: NonProfitOrgProfileResponse['id'];
}) => {
  const colors = useColor();
  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('sign_in.nonProfit.pastors.title')}
          </Text>
          {/* // TODO: update tooltip title  */}
          <InfoButton title={i18n.t('sign_in.nonProfit.pastors.title')} />
        </View>
        {canEdit && (
          <EditButton
            onPress={() =>
              router.navigate({
                pathname: '/edit/npoPastors',
                params: {
                  initialList: JSON.stringify(data),
                  npoId: npoId
                }
              })
            }
          />
        )}
      </View>
      <View style={styles.content}>
        {data && data.length > 0 ? (
          data.map((v, index) => (
            <View style={styles.row} key={index}>
              <Text style={[styles.valueText, { color: colors.titleText }]} fontWeight="700" numberOfLines={2}>
                {v.position}
              </Text>
              <Text style={{ flex: 1 }} numberOfLines={2}>
                {v.fullName}
              </Text>
            </View>
          ))
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default PastorItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  row: {
    flexDirection: 'row',
    flex: 1,
    marginTop: 3
  },

  valueText: {
    minWidth: 80,
    marginRight: 10,
    marginBottom: 8
  }
});
